import React, { useContext, useEffect, useState } from "react";
// React Bootstrap
import { Accordion, Card, Button, Container } from "react-bootstrap";
// // Contexto
import { ModalContext } from "../../../context/modalContext";
import { AlertBoxContext } from "../../../context/alertBoxContext";
// jquery
import $ from "jquery";
// Custom spinner
import CustomSpinner from "../../generic/CustomSpinner";
// Form
import AddSituacionParticular from "../formularios/SituacionParticularAdd";
import SituacionParticular from "./SituacionParticular";
// Componentes

const SituacionesParticulares = ({ idHermana, state, accessLevel, ...props }) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
  // Situaciones particulares
  const [situacionesParticulares, setSituacionesParticulares] = useState([]);
  // Custom spinner
  const [loading, setLoading] = useState(false);
  // Alertas
  const { addAlert } = useContext(AlertBoxContext);

  //********************************************** REQUESTS ****************************************************
  //------------------------------------------------ GET -------------------------------------------------------
  // Obtiene todas las situaciones particulares de la hermana
  const getSituacionesParticulares = () => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/hermanas/${idHermana}/situacionesParticulares?count=900`,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  //------------------------------------------------ POST -------------------------------------------------------
  // Añade una situación particular de la hermana
  const postSituacionParticular = (data) => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/hermanas/${idHermana}/situacionesParticulares`,
      method: "POST",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };

  //********************************************** HANDLERS ****************************************************/
  // Manejador para las situaciones particulares
  const handleGetSituacionesParticulares = () => {
    setLoading(true);
    getSituacionesParticulares()
      .then((response) => {
        setLoading(false);
        setSituacionesParticulares(response.items);
      })
      .catch(() => {
        setLoading(false);
        addAlert("Error", "Error al pedir las situaciones particulares de la hermana", "danger");
      });
  };

  const handlePostSituacionParticular = (data) => {
    modalSetShow(false);
    setLoading(true);
    postSituacionParticular(data)
      .then((response) => {
        setLoading(false);
        setSituacionesParticulares([response, ...situacionesParticulares]);
        addAlert("Éxito", "Se ha añadido la situación particular correctamente", "success");
      })
      .catch(() => {
        setLoading(false);
        addAlert("Error", "Error al añadir la situacion particular de la hermana", "danger");
      });
  };

  // UEF

  useEffect(() => {
    handleGetSituacionesParticulares();
  }, []);

  const deleteSituacionParticular = (idSituacionPersonal) => {
    let situacionPersonal = situacionesParticulares.find((situacionPersonal) => situacionPersonal.id === idSituacionPersonal);
    let situacionesPersonalesMenos1 = [...situacionesParticulares];
    situacionesPersonalesMenos1.splice(situacionesPersonalesMenos1.indexOf(situacionPersonal), 1);
    setSituacionesParticulares(situacionesPersonalesMenos1);
  };

  return (
    <div style={{ position: "relative" }}>
      <CustomSpinner animation={"border"} loading={loading} />
      <Accordion defaultActiveKey="1">
        <Card>
          <Card.Header>
            <Accordion.Toggle eventKey="0" as={Button} variant="link">
              Situaciones Particulares
            </Accordion.Toggle>
            {accessLevel >= 9 && (
              <Button
                variant="outline-primary"
                size="sm"
                className="float-right mr-4"
                onClick={() => {
                  modalSetShow(true, "60%");
                  modalSetTitle("Añadir situación particular");
                  modalSetContent(<AddSituacionParticular situacionesParticulares={situacionesParticulares} submissionHandler={handlePostSituacionParticular} />);
                }}
              >
                Añadir
              </Button>
            )}
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <p>
                <small>Ordenado de más reciente a más antiguo</small>
              </p>
              {situacionesParticulares.length ? (
                situacionesParticulares.map((situacion) => {
                  return <SituacionParticular accessLevel={accessLevel} key={situacion.id} situacionParticular={situacion} deleteSituacionParticularState={deleteSituacionParticular} />;
                })
              ) : (
                <p>No hay situaciones particulares actualmente.</p>
              )}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default SituacionesParticulares;
